module.exports = __webpack_public_path__ + "static/media/mision.25bb5956.png";